<template>
    <div>
      <b-card>
        <h4 class="mb-3">Sistem Ayarları</h4>
        <b-row>
          <b-col
            v-for="(item, index) in localSettings"
            :key="item.setting_key"
            cols="12"
          >
            <b-card no-body>
              <b-row align-v="center" class="p-2">
                <b-col md="4" class="font-weight-bold">
                  {{ item.name }}
                  <div class="text-muted small">{{ item.setting_key }}</div>
                  <div v-if="item.description" class="text-muted small mt-1">
                    {{ item.description }}
                  </div>
                </b-col>
                <b-col md="4">
                  <template v-if="isToggleSetting(item)">
                    <div class="d-flex align-items-center">
                      <b-form-checkbox
                        :checked="getToggleValue(item)"
                        class="custom-control-success mb-0"
                        name="setting-toggle"
                        switch
                        switch-variant="success"
                        @change="onToggleChange(item, $event)"
                      />
                      <span class="ml-2 text-muted small">
                        {{ getToggleLabel(item) }}
                      </span>
                    </div>
                  </template>
                  <b-form-input
                    v-else-if="item.setting_key === 'bio_short_code'"
                    v-model="item.setting_value"
                    :maxlength="14"
                    :pattern="'^[A-Za-z0-9_]{1,10}$'"
                    :placeholder="'En fazla 10 karakter, harf/rakam/alt tire'"
                    @input="onInputBioShortCode(item)"
                  />
                  <b-form-input
                    v-else
                    v-model="item.setting_value"
                  />
                </b-col>
                <b-col md="2" class="text-muted small align-self-center">
                  Son Güncelleme: <br /> {{ formatDate(item.updated_at) }}
                </b-col>
                <b-col md="2" class="text-right">
                  <b-button
                    size="sm"
                    variant="primary"
                    :disabled="item.saving"
                    @click="saveSetting(index)"
                  >
                    Kaydet
                  </b-button>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </template>
  <script>
  import {
    BCard, BButton, BFormCheckbox, BFormInput, BRow, BCol,
  } from 'bootstrap-vue'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import { mapActions, mapGetters } from 'vuex'
  
  export default {
    components: {
      BCard,
      BButton,
      BFormCheckbox,
      BFormInput,
      BRow,
      BCol,
    },
    data() {
      return {
        localSettings: [],
      }
    },
    computed: {
      ...mapGetters('settings', ['allSettings']),
    },
    watch: {
      allSettings: {
        handler(val) {
          // Store’daki ayarları local’e kopyala (input için)
          this.localSettings = val
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.fetchSettings()
    },
    methods: {
      ...mapActions('settings', ['fetchSettings', 'updateSetting']),
      isToggleSetting(item) {
        const type = String(item?.type || '').toLowerCase()
        return ['boolean', 'bool', 'switch', 'toggle', 'checkbox', 'check'].includes(type)
      },
      getToggleValue(item) {
        const value = item?.setting_value
        if (typeof value === 'boolean') return value
        if (value === 1 || value === '1' || value === 'true') return true
        return false
      },
      getToggleLabel(item) {
        return this.getToggleValue(item) ? 'Açık' : 'Kapalı'
      },
      onToggleChange(item, value) {
        item.setting_value = value ? '1' : '0'
      },
      onInputBioShortCode(item) {
        if (item.setting_key === 'bio_short_code') {
          item.setting_value = item.setting_value.replace(/[^A-Za-z0-9_]/g, '').slice(0, 14)
        }
      },
      async saveSetting(index) {
        const setting = this.localSettings[index]
        
        if (!setting || !setting.setting_key) return
        setting.saving = true
        try {
          await this.updateSetting({ key: setting.setting_key, value: setting.setting_value })
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Başarılı',
              icon: 'CheckIcon',
              variant: 'success',
              text: `"${setting.setting_key}" ayarı güncellendi.`,
            },
          })
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Hata',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: `"${setting.setting_key}" ayarı güncellenemedi.`,
            },
          })
        } finally {
          setting.saving = false
        }
      },
      formatDate(dt) {
        if (!dt) return ''
        const d = new Date(dt)
        return d.toLocaleString('tr-TR')
      },
    },
  }
  </script>
  
  <style scoped>
  .font-weight-bold {
    font-weight: bold;
  }
  </style>